<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useBulkExport } from '@/composables/useBulkExport';
import { type RecordsBulkExportType } from '@/api/bulk-exports';
import BulkExportSnackbars from '@/components/bulk-export-snackbars.vue';

interface Props {
  exportType: RecordsBulkExportType;
  recordIds: number[];
  fromDate: string;
  toDate: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), { disabled: false });

const { t } = useI18n();
const { startExport, isExporting, progressLabel, lastResult, lastErrorMessage } = useBulkExport();

function onClick() {
  startExport({
    exportType: props.exportType,
    recordIds: props.recordIds,
    fromDate: props.fromDate,
    toDate: props.toDate,
  });
}
</script>
<template>
  <v-btn
    icon="mdi-file-pdf-box"
    class="mr-4 mb-6"
    color="primary"
    variant="text"
    density="comfortable"
    :loading="isExporting"
    :disabled="disabled || isExporting || recordIds.length === 0"
    @click="onClick"
  >
    <v-icon icon="mdi-file-pdf-box" />
    <v-tooltip
      activator="parent"
      location="top"
    >
      {{ t('bulkExports.download') }}
    </v-tooltip>
  </v-btn>
  <bulk-export-snackbars
    :is-exporting="isExporting"
    :progress-label="progressLabel"
    :last-result="lastResult"
    :last-error-message="lastErrorMessage"
  />
</template>
